"use client";

import type { ReactNode } from "react";
import {
  Controller,
  useFormContext,
  type ControllerProps,
} from "react-hook-form";
import Select, { type SelectProps } from "@mui/material/Select";
import { FormField } from "./FormField";

export type FormSelectProps = {
  name: string;
  label?: ReactNode;
  helperText?: ReactNode;
  children: ReactNode;
  rules?: ControllerProps["rules"];
} & Omit<
  SelectProps,
  "name" | "value" | "onChange" | "error" | "label" | "children"
>;

export const FormSelect = ({
  name,
  label,
  helperText,
  required,
  children,
  rules,
  ...rest
}: FormSelectProps) => {
  const { control } = useFormContext();
  const labelId = `${name}-label`;
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, ...field }, fieldState }) => (
        <FormField
          label={label}
          helperText={fieldState.error?.message ?? helperText}
          error={!!fieldState.error}
          required={required}
          htmlFor={name}
          labelId={labelId}
        >
          <Select
            id={name}
            labelId={labelId}
            {...rest}
            {...field}
            inputRef={ref}
            value={field.value ?? ""}
            error={!!fieldState.error}
            required={required}
          >
            {children}
          </Select>
        </FormField>
      )}
    />
  );
};
